import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=4fae0aa8"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fae0aa8')) {
      api.createRecord('4fae0aa8', component.options)
    } else {
      api.reload('4fae0aa8', component.options)
    }
    module.hot.accept("./menu.vue?vue&type=template&id=4fae0aa8", function () {
      api.rerender('4fae0aa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/partials/menu.vue"
export default component.exports